import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceToggle from './components/ServiceToggle';
import DraftingServices from './components/DraftingServices';
import TakeoffServices from './components/TakeoffServices';
import ProcessSection from './components/ProcessSection';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';

export default function ServicesPage() {
  const [activeService, setActiveService] = useState<'drafting' | 'takeoff'>('drafting');

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSection />
        <ServiceToggle activeService={activeService} onToggle={setActiveService} />

        {activeService === 'drafting' ? (
          <DraftingServices />
        ) : (
          <TakeoffServices />
        )}

        <ProcessSection serviceType={activeService} />
        <BenefitsSection serviceType={activeService} />
        <ComparisonSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}